// @flow

import { connect } from 'react-redux';
import SystemWarnBanner from './syswarn';
import { hideNavBar, showNavBar } from '../../../services/ui';
import { closeSysWarn } from '../../../services/sam';

const mapState = ({ sam }) => ({
  syswarnmessage: sam.syswarnmessage,
  samClosed: sam.samClosed,
  lastCheck: sam.lastCheck,
});

const mapDispatch = {
  hideNavBar: () => dispatch => dispatch(hideNavBar()),
  showNavBar: () => dispatch => dispatch(showNavBar()),
  closeSysWarn,
};

export default connect(
  mapState,
  mapDispatch,
)(SystemWarnBanner);
